export default __webpack_public_path__ + "static/media/Greataxe of the Crimson Sea.0cc47ced.jpg";